import {type RouteRecordRaw} from "vue-router";

export const Payment: RouteRecordRaw = {
    path: '/payment/:sessionId',
    name: 'payment',
    component: () => import('./payment.vue'),
};

export const ProcessingSession: RouteRecordRaw = {
    path: '/payment/processing/:sessionId',
    name: 'processingSession',
    component: () => import('./processing.vue'),
};

export default [
    Payment,
    ProcessingSession,
];
